<template>
    <div>

        <Divider :align="'left'">
            Базовые настройки
        </Divider>
        <div class="flex flex-row flex-wrap">
            <FormInput v-model="value.maxOpenDeals"
                       title="maxOpenDeals"
                       min="1" step="1"
                       description="Максимальное количество открытых сделок. Новые сделки выше этого значения совершаться не будут.
                       Отредактируйте, если предел достигнут, а деньги, которые вы хотите пустить в оборот, ещё есть."
            />

            <FormInput v-model="value.buyAmountUsd"
                       title="buyAmountUsd"
                       min="10" step="1"
                       description="Количество USDT, которое бот будет тратить при совершении сделки. Существует минимальное количество,
                       ниже которого Binance не даёт торговать, оно близко к 10."
            />

            <FormInput v-model="value.minProfit"
                       title="minProfit"
                       min="1" step="0.001"
                       description="Продавать, когда цена достигнет данную долю. (1.015 == цена выросла на 1.5%)"
            />

            <FormInput v-model="value.stopLoss"
                       title="stopLoss"
                       min="0" step="0.01"
                       description="Момент, когда продавать открытую сделку в убыток. 0 - никогда не продавать. 0.97 - продавать, когда курс упадёт на 3% от закупочного"
            />
        </div>

        <Divider :align="'left'">
            Настройки сетки
        </Divider>
        <div class="flex flex-row flex-wrap">
            <FormInput v-model="value.step"
                       title="step"
                       min="0" step="0.001"
                       description="Шаг сетки" />
            <FormCheckbox v-model="value.useBandForBuy"
                       title="useBandForBuy"
                       description="Покупать только под нижней границей коридора цены (кроме растущего тренда)" />
            <FormCheckbox v-model="value.useBandForBuyOnUpTrend"
                       title="useBandForBuyOnUpTrend"
                       description="Покупать только под нижней границей коридора цены и на растущем тренде" />
            <FormInput v-model="value.downFactorGrid"
                       title="downFactorGrid"
                       min="1" step="0.1"
                       description="" />
            <FormCheckbox v-model="value.startGridOnLowBand"
                          title="startGridOnLowBand"
                          description="" />
            <FormInput v-model="value.widthDealOnGrid"
                       title="widthDealOnGrid"
                       min="0" step="0.1"
                       description="" />
            <FormInput v-model="value.minutesBetweenDeals"
                       title="minutesBetweenDeals"
                       min="0" step="1"
                       description="" />
        </div>

        <Divider :align="'left'">
            Канал движения цены
        </Divider>
        <div class="flex flex-row flex-wrap">
            <FormInput v-model="value.bandEmaLength"
                       title="bandEmaLength"
                       min="10" step="10"
                       description="Период скользящей средней" />
            <FormInput v-model="value.bandTrLength"
                       title="bandTrLength"
                       min="10" step="10"
                       description="Период скользящей средней определения True Range цены" />
            <FormInput v-model="value.bandFactorHighBorder"
                       title="bandFactorHighBorder"
                       min="0.1" step="0.1"
                       description="Множитель верхней границы коридора" />
            <FormInput v-model="value.bandFactorLowBorder"
                       title="bandFactorLowBorder"
                       min="0.1" step="0.1"
                       description="Множитель нижней границы коридора" />

        </div>

        <Divider :align="'left'">
            Тренд
        </Divider>
        <div class="flex flex-row flex-wrap">
            <FormInput v-model="value.trendLength"
                       title="trendLength"
                       min="1" step="1"
                       description="Период скользящей средней" />
            <FormInput v-model="value.trendAlgorithm"
                       title="trendAlgorithm"
                       step="10"
                       description="Алгоритм определения тренда" />
            <FormInput v-model="value.trendTimeGapUp"
                       title="trendTimeGapUp"
                       min="10" step="10"
                       description="" />
            <FormInput v-model="value.trendTimeGapDown"
                       title="trendTimeGapDown"
                       min="10" step="10"
                       description="" />
            <FormInput v-model="value.trendSpeedToUp"
                       title="trendSpeedToUp"
                       min="0.0001" step="0.0001"
                       description="" />
            <FormInput v-model="value.trendSpeedToDown"
                       title="trendSpeedToDown"
                       max="-0.0001" step="0.0001"
                       description="" />
            <FormInput v-model="value.trendMaxTailDown"
                       title="trendMaxTailDown"
                       min="10" step="10"
                       description="" />
            <FormInput v-model="value.trendMaxTailUp"
                       title="trendMaxTailUp"
                       min="10" step="10"
                       description="" />

        </div>



    </div>
</template>

<script>
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Divider from 'primevue/divider';
import Checkbox from 'primevue/checkbox';
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";
import FormInput from "@/Settings/FormItems/FormInput.vue";
import FormCheckbox from "@/Settings/FormItems/FormCheckbox.vue";
export default {
    props: {
        value: Object,
        countOpenDeals: Number|null,
    },
    components:{
        FormInput, FormCheckbox,
        InputSwitch,
        Dropdown,
        InputNumber,
        InputText, Divider, Checkbox
    },
    data(){
        return {

        }
    },
    mounted(){

    },
    watch:{

    },
    methods:{

    }
}
</script>
